import type { RelatedPlace } from "~/lib/api";
import { RELATED_PLACE_CATEGORIES } from "~/lib/relatedPlaces";
import { RelatedPlacesSection } from "../RelatedPlacesSection";

interface BackcountryRelatedSectionProps {
  placeId: string;
  relatedPlaces: RelatedPlace[];
  canEdit?: boolean;
  onRemove?: (relatedPlaceId: string) => Promise<void>;
  onSelect?: (place: RelatedPlace) => void;
}

export function BackcountryRelatedSection(props: BackcountryRelatedSectionProps) {
  return <RelatedPlacesSection {...props} title="Nearby" categories={RELATED_PLACE_CATEGORIES} />;
}
